import * as service from './service'
export default {
  namespace: 'equipmentMallActivityList',
  state: {
    activityData: { }
  },
  effects: {
    * getMarketingActivity ({ payload }, { call, put }) {
      const res = yield call(service.getMarketingActivity, payload)
      yield put({
        type: 'save',
        payload: {
          activityData: res.data.data
        }
      })
      return res
    },
    * queryMarketingActivitySaleList ({ payload }, { call, put }) {
      const res = yield call(service.queryMarketingActivitySaleList, payload)
      return res
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
